import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { sharedApiManager } from "../apiManager";

const useIdVerificationFunction = () => {
  const { payload, tenentId, tenent } = useSelector((state) => state.tenent);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("sso_code");
  const ERROR_PATH = `/${tenent}/error`;
  const SUCCESS_PATH = `/${tenent}/success`;

  const func = {
    svStandard: async function () {
      if (!token) {
        return navigate(ERROR_PATH);
      }

      if (!payload) {
        navigate(ERROR_PATH);
      } else if (payload) {
        const data = await sharedApiManager.authorSocialValidation(
          token,
          tenentId,
          payload
        );

        if (!data) {
          navigate(ERROR_PATH);
        } else {
          navigate(SUCCESS_PATH);
        }
      }
    },
  };

  return {
    func,
  };
};

export default useIdVerificationFunction;
